import { EmailClient } from "@amazon-connect/email";
import type { AmazonConnectProvider } from "@amazon-connect/core";
import type { ClientModule } from "../types";

/**
 * EmailClient: email channel data and draft/send operations. Every request takes exactly one
 * object argument in the real SDK (see `sdk-signatures.md`) — the descriptor's single `json`
 * arg IS that object, passed positionally, never wrapped in another envelope.
 */
export const emailModule: ClientModule = {
  id: "email",
  label: "Email",
  pkg: "@amazon-connect/email",
  clientExport: "EmailClient",
  kind: "observable",
  create: (provider: AmazonConnectProvider) =>
    new EmailClient({ provider }) as unknown as Record<string, unknown>,
  events: [
    { name: "onAcceptedEmail", off: "offAcceptedEmail" },
    { name: "onDraftEmailCreated", off: "offDraftEmailCreated" },
  ],
  requests: [
    // getEmailData({ contactId, activeContactId }) — a params object, not a bare contactId.
    {
      name: "getEmailData",
      args: [{ k: "params", type: "json", required: true }],
    },
    {
      name: "getEmailThread",
      args: [{ k: "getEmailThreadParams", type: "json", required: true }],
    },
    // listFromEmailAddresses(params) is required, not zero-arg.
    {
      name: "listFromEmailAddresses",
      args: [{ k: "params", type: "json", required: true }],
    },
    {
      name: "createDraftEmail",
      args: [{ k: "contactCreation", type: "json", required: true }],
      mutating: true,
    },
    {
      name: "sendEmail",
      args: [{ k: "emailContact", type: "json", required: true }],
      mutating: true,
    },
  ],
};
